import { Dispatch, SetStateAction, useState } from 'react'
import styled from '@emotion/styled'
import { StyledHTMLElement } from 'shop/theme/types'
import {
  ButtonsContainer,
  Header,
  OptionHeader,
  OptionsContainer
} from './commonStyles'
import { IoChevronBack as BackChevron } from 'react-icons/io5'
import { Button } from 'shop/components/Controls'
import StoreSortCalendar from './StoreSortCalendar'
import ExpandableDiv from 'shop/components/ExpandableContainer/ExpandableDiv'
// import DaysSelectorList from './DaySelector'
// import { addDays, isAfter } from 'date-fns'
// import { disableBlueTapHighlight } from 'shop/components/common'
// import { useMediaQueries } from 'shop/hooks'

type Props = {
  selectedFulfillmentDate: Date
  setShowDatetimeSection: Dispatch<SetStateAction<boolean>>
  setSelectedFulfillmentDate: Dispatch<SetStateAction<Date>>
  maxDaysInAdvance?: number
}

const StoreSortDatetimeSelect = ({
  selectedFulfillmentDate,
  setShowDatetimeSection,
  setSelectedFulfillmentDate,
  maxDaysInAdvance = 14
}: Props) => {
  // DISABLE: Only show Calendar for now
  // const isSelectedDayMoreThanDayList = isAfter(
  //   selectedFulfillmentDate,
  //   new Date(addDays(new Date(), 13))
  // )
  const [tempSelectedFulfillmentDate, setTempSelectedFulfillmentDate] =
    useState<Date>(selectedFulfillmentDate)
  // DISABLE: Only show Calendar for now
  // const [showDayList, setShowDayList] = useState(!isSelectedDayMoreThanDayList)
  // const [showCalendar, setShowCalendar] = useState(isSelectedDayMoreThanDayList)
  // const [noTransition, setNoTransition] = useState(true)
  // const { isMobile } = useMediaQueries()

  // // create an array of Dates from today up until the max of maxDaysInAdvance or 14
  // let dayArray: Date[] = new Array(Math.min(maxDaysInAdvance, 14)).fill(
  //   new Date()
  // )
  // dayArray = dayArray.map((day, index) => {
  //   const tempDay = new Date(day)
  //   tempDay.setDate(tempDay.getDate() + index)
  //   return tempDay
  // })

  const handleApplyFulfillmentDatetime = () => {
    if (
      tempSelectedFulfillmentDate &&
      tempSelectedFulfillmentDate !== selectedFulfillmentDate
    ) {
      setSelectedFulfillmentDate(tempSelectedFulfillmentDate)
    }

    setTimeout(() => setShowDatetimeSection(false), 100)
  }

  // DISABLE: Only show Calendar for now
  // const handleDaySelectorSwitch = () => {
  //   if (showCalendar) {
  //     setShowCalendar(false)
  //     setTimeout(() => setShowDayList(true), 100)
  //   }
  //   if (showDayList) {
  //     setShowDayList(false)
  //     setTimeout(() => setShowCalendar(true), 100)
  //   }
  // }
  // useEffect(() => {
  //   // on first load, don't have a transition effect for the dayList
  //   if (showCalendar) setNoTransition(false)
  // }, [showCalendar])

  return (
    <>
      <Header>
        <BackChevron
          onClick={() => {
            setShowDatetimeSection(false)
            setTimeout(() => {
              setTempSelectedFulfillmentDate(selectedFulfillmentDate)
            }, 100)
          }}
        />
        Choose when
      </Header>
      <OptionsContainer style={{ gap: '0px' }}>
        <HeaderContainer>
          <OptionHeader>Time</OptionHeader>
          {/* DISABLE: Only show Calendar for now */}
          {/* <CalendarSwitchControl onClick={handleDaySelectorSwitch}>
            {showCalendar ? 'Hide full calendar' : 'View full calendar'}
          </CalendarSwitchControl> */}
        </HeaderContainer>
        {/* DISABLE: Only show Calendar for now  */}
        {/* <ExpandableDiv
          collapsedHeight={0}
          isExpanded={showDayList}
          transition={
            !showDayList
              ? 'height 400ms ease'
              : noTransition
                ? 'none'
                : undefined
          } // slow the transition a little on way out
          containerStyles={{ margin: isMobile ? '0' : '0 -20px' }}
        >
          <DaysSelectorList
            days={dayArray}
            tempSelectedFulfillmentDate={tempSelectedFulfillmentDate}
            onSelect={(day: Date) => {
              setTempSelectedFulfillmentDate(day)
            }}
          />
        </ExpandableDiv> */}
        <ExpandableDiv
          collapsedHeight={0}
          isExpanded={true}
          transition={'none'}
          // transition={!showCalendar ? 'height 400ms ease' : undefined} // slow the transition a little on way out
        >
          <StoreSortCalendar
            tempSelectedFulfillmentDate={tempSelectedFulfillmentDate}
            setTempSelectedFulfillmentDate={setTempSelectedFulfillmentDate}
            maxDaysInAdvance={maxDaysInAdvance}
          />
        </ExpandableDiv>
      </OptionsContainer>
      <ButtonsContainer>
        <Button variant='primary' onClick={handleApplyFulfillmentDatetime}>
          Apply
        </Button>
      </ButtonsContainer>
    </>
  )
}

const HeaderContainer = styled.div<StyledHTMLElement>(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'space-between',
  paddingBottom: '12px'
}))

// DISABLE: Only show Calendar for now
// const CalendarSwitchControl = styled.div<StyledHTMLElement, Required<Theme>>(
//   ({ theme }) => ({
//     fontSize: '16px',
//     fontWeight: 500,
//     fontFamily: theme.fonts['body'].family,
//     color: '#59595A',
//     cursor: 'pointer',
//     alignSelf: 'flex-end',
//     ...disableBlueTapHighlight(theme),

//     '&:hover': {
//       opacity: 0.8
//     },
//     '&:active': {
//       opacity: 0.6
//     }
//   })
// )

export default StoreSortDatetimeSelect
